import React from 'react';
import {
  Copy,
  Link,
  Squish,
  SvgCaretFirst,
  SvgCaretLast,
  SvgCaretLeft,
  SvgCaretRight,
} from '@grubhubprod/gh-cookbook-react';

export type NavType = 'first' | 'previous' | 'next' | 'last';

export interface PaginationNavLinkProps {
  type: NavType;
  targetPage: number;
  disabled: boolean;
  onClick: (page: number) => void;
}

const NAV_CONFIG = {
  first: { label: 'First', Icon: SvgCaretFirst },
  previous: { label: 'Previous', Icon: SvgCaretLeft },
  next: { label: 'Next', Icon: SvgCaretRight },
  last: { label: 'Last', Icon: SvgCaretLast },
};

export const PaginationNavLink: React.FC<PaginationNavLinkProps> = ({
  type,
  targetPage,
  disabled,
  onClick,
}) => {
  const { label, Icon } = NAV_CONFIG[type];

  const handleClick = (e: React.MouseEvent): void => {
    e.preventDefault();
    if (!disabled) {
      onClick(targetPage);
    }
  };

  return (
    <Link href="?" onClick={handleClick} aria-label={label} disabled={disabled}>
      <Squish inset="x-sm">
        <Copy variant="body" color="primaryText">
          <Icon size="16px" />
        </Copy>
      </Squish>
    </Link>
  );
};
